"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = require("@angular/core");
var idm_authentication_client_js_1 = require("@synisys/idm-authentication-client-js");
var idm_common_util_frontend_1 = require("@synisys/idm-common-util-frontend");
var idm_application_properties_service_client_js_1 = require("@synisys/idm-application-properties-service-client-js");
var rxjs_1 = require("rxjs");
var operators_1 = require("rxjs/operators");
var idm_session_data_provider_api_js_1 = require("@synisys/idm-session-data-provider-api-js");
var VcConfigurationPageService = /** @class */ (function () {
    function VcConfigurationPageService(http, applicationPropertiesService, currentLanguageProvider) {
        var _this = this;
        this.http = http;
        this.applicationPropertiesService = applicationPropertiesService;
        this.currentLanguageProvider = currentLanguageProvider;
        this.CONFERENCE_SERVICE_URI_KEY = 'video-conference-service-url';
        this.SET_ACCOUNT_CREDENTIALS = idm_common_util_frontend_1.StringTemplate.createTemplate(templateObject_1 || (templateObject_1 = __makeTemplateObject(["", "/youtube/account/login"], ["", "/youtube/account/login"])), 'serviceUri');
        this.ACCOUNT_AUTHENTICATION = idm_common_util_frontend_1.StringTemplate.createTemplate(templateObject_2 || (templateObject_2 = __makeTemplateObject(["", "/youtube/account/authenticate"], ["", "/youtube/account/authenticate"])), 'serviceUri');
        this.YOUTUBE_CHANNEL_INFO = idm_common_util_frontend_1.StringTemplate.createTemplate(templateObject_3 || (templateObject_3 = __makeTemplateObject(["", "/youtube/account/channel"], ["", "/youtube/account/channel"])), 'serviceUri');
        this.videoConferenceServiceUrl$ = rxjs_1.Observable.fromPromise(this.applicationPropertiesService.getProperty(this.CONFERENCE_SERVICE_URI_KEY));
        this.currentLanguageProvider.getCurrentLanguage().pipe(operators_1.take(1))
            .subscribe(function (currentLanguage) {
            _this.languageId = currentLanguage.getId();
        });
    }
    VcConfigurationPageService.prototype.settingAccountCredentials = function (credentials) {
        var _this = this;
        return this.videoConferenceServiceUrl$.pipe(operators_1.switchMap(function (serviceUri) {
            var url = _this.SET_ACCOUNT_CREDENTIALS.replaceTemplate({
                serviceUri: serviceUri
            });
            var body = {
                "client-id": (credentials && credentials.client_id.getValue(_this.languageId)) || null,
                "client-secret": (credentials && credentials.client_secret.getValue(_this.languageId)) || null
            };
            return _this.http.post(url, body); // todo test
        }));
    };
    VcConfigurationPageService.prototype.checkingAccountAuthentication = function () {
        var _this = this;
        return this.videoConferenceServiceUrl$.pipe(operators_1.switchMap(function (serviceUri) {
            var url = _this.ACCOUNT_AUTHENTICATION.replaceTemplate({
                serviceUri: serviceUri
            });
            return _this.http.post(url, null); // todo test
        }));
    };
    VcConfigurationPageService.prototype.getChanelInfo = function () {
        var _this = this;
        return this.videoConferenceServiceUrl$.pipe(operators_1.switchMap(function (serviceUri) {
            var url = _this.YOUTUBE_CHANNEL_INFO.replaceTemplate({
                serviceUri: serviceUri
            });
            return _this.http.get(url); // todo test
        }));
    };
    VcConfigurationPageService = __decorate([
        core_1.Injectable(),
        __metadata("design:paramtypes", [idm_authentication_client_js_1.HttpClientWrapper,
            idm_application_properties_service_client_js_1.ApplicationPropertiesService,
            idm_session_data_provider_api_js_1.CurrentLanguageProvider])
    ], VcConfigurationPageService);
    return VcConfigurationPageService;
}());
exports.VcConfigurationPageService = VcConfigurationPageService;
var templateObject_1, templateObject_2, templateObject_3;
//# sourceMappingURL=vc-configuration-page.service.js.map